exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".icon-primary-color {\n  color: #4a84ae;\n  padding-left: 2rem;\n  padding-right: 2rem;\n  font-weight: bolder;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/pages/pointofsale/styles/components/icon.less
// module id = 3165
// module chunks = 0